import React from "react";

export const Chemical = ({ children }: { children: React.ReactNode }) => {
  const child = children?.toString() ?? "";

  return (
    <span
      dangerouslySetInnerHTML={{
        __html: child
          .replace(/\^(.)/g, "<sup>$1</sup>")
          .replace(/_(.)/g, "<sub>$1</sub>"),
      }}
    />
  );
};
